'use server';

import request from '../../../../api/request';
import { actionKitImpFunction } from '../../../../components/ozmoit/common/action-kit-imp';

export const getAdmissionProcessesFormAction = actionKitImpFunction(
  async () => {
    const response = await request<{
      processTypes: any[];
      periods: any[];
      // Forma cruda de PaydayService.getPaydayOptions() (entriesToOptions):
      // { id, name }, no { label, value }.
      paydays: { id: string; name: string }[];
    }>('/maintainers-portal/academic-offer/admission-processes/form', {
      method: 'GET',
    });

    if (response.error) {
      throw new Error(
        response.error.error.message ||
          'Error fetching admission processes form',
      );
    }

    return response.data;
  },
);

export const getAdmissionProcessesAction = actionKitImpFunction(
  async ({
    periodId,
    processTypeId,
  }: {
    periodId: number;
    processTypeId?: number | null;
  }) => {
    const response = await request<any[]>(
      '/maintainers-portal/academic-offer/admission-processes',
      {
        method: 'GET',
        params: { periodId, processTypeId },
      },
    );

    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error fetching admission processes',
      );
    }

    return response.data;
  },
);

export const deleteAdmissionProcessAction = actionKitImpFunction(
  async ({ processId }: { processId: number }) => {
    const response = await request(
      `/maintainers-portal/academic-offer/admission-processes/${processId}`,
      {
        method: 'DELETE',
      },
    );

    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error deleting admission process',
      );
    }

    return response.data;
  },
);

export const updateAdmissionProcessStagesAction = actionKitImpFunction(
  async ({
    processId,
    stages,
  }: {
    processId: number;
    stages: {
      id: number;
      startDate: string | null;
      endDate: string | null;
    }[];
  }) => {
    const response = await request(
      `/maintainers-portal/academic-offer/admission-processes/${processId}/stages`,
      {
        method: 'PUT',
        data: { stages },
      },
    );

    if (response.error) {
      throw new Error(
        response.error.error.message ||
          'Error updating admission process stages',
      );
    }

    return response.data;
  },
);

export const updateAdmissionAction = actionKitImpFunction(
  async ({ admissionId, data }: { admissionId: number; data: any }) => {
    const response = await request<any>(
      `/maintainers-portal/academic-offer/admission-processes/admission/${admissionId}`,
      {
        method: 'PUT',
        data,
      },
    );

    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error updating admission',
      );
    }

    return response.data;
  },
);
